import BaseApiController from 'controller/baseresourcecontroller';

export default class SecurityController extends BaseApiController {
  constructor () {
    super('mvc/security');
  }

  async GetAuthorization (resourcecodes) {
    return super.Post('getauthorization', resourcecodes);
  }

  async IsSupportVerified () {
    return super.Get('IsSupportVerified');
  }

  async CheckVerificationCode(code, verificationcode) {
    return super.Post('CheckVerificationCode', { code: code, verificationcode: verificationcode }); 
  }
}